<template>
  <div class="animated fadeIn">
    <b-tabs
      active-nav-item-class="font-weight-bold text-uppercase text-danger">
      <b-tab title="Admin Information">
        <b-card border-variant="primary">
          <div slot="header">
            <strong>Admin Information</strong>
            <span class="pull-right" v-if="!add && model.created_at">Joined_at  : {{model.created_at | datetime}}</span>
          </div>
          <b-row>
            <b-col md="4">
              <b-form-group label="Allow login" label-for="ph_use"
                v-b-tooltip.hover title="Allow login.">
                <c-switch color="info" label size="sm" v-model="model.is_alive" :disabled="lock" />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label>Permissions</label>
                <label for="ph_group" v-b-tooltip.hover title="Permission."></label>
                <v-select v-if="!lock" label="text" v-model="model.permissions" :options="codes.permissions_admin"></v-select>
                <b-form-input type="text" v-if="lock" :value="model.permissions" plaintext></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4" v-if="model.id">
              <b-form-group>
                <label>Last_visit</label>
                <p>
                  {{model.last_visit | datetime}} @ {{model.last_addr}}
                </p>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <label for="ph_username" v-b-tooltip.hover title="Username">Username(ID) (*)
                  <span v-if="model.is_del" class="text-danger">Deleted user, Logging in is not possible even if you allow it.</span>
                </label>
                <b-form-input :disabled="!add || lock" type="text" id="ph_username" v-model="model.username" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- {{model}} -->
          <!-- <password :badge="true" v-model="model.new_password" :strengthMeterOnly="false" :toggle="false" @score="showScore" @feedback="showFeedback" /> -->
          <b-row v-show="add || !lock">
            <b-col md="6">
              <b-form-group>
                <label for="ph_pass">{{add ? 'User' : 'Change'}} Password(*)</label>
                <b-form-input type="password" id="ph_pass" v-model="model.new_password" :plaintext="lock"></b-form-input>
                <b-badge v-if="model.new_password"  :variant="password_policy('number') ? 'success' : 'danger'"> Number </b-badge>
                <b-badge v-if="model.new_password"  :variant="password_policy('uppercase') ? 'success' : 'danger'"> Upper Characters </b-badge>
                <b-badge v-if="model.new_password"  :variant="password_policy('lowercase') ? 'success' : 'danger'"> Lower Characters </b-badge>
                <b-badge v-if="model.new_password"  :variant="password_policy('spacial') ? 'success' : 'danger'"> Special Characters </b-badge>
                <b-badge v-if="model.new_password"  :variant="password_policy('length') ? 'success' : 'danger'">
                  Min Length : 10
                </b-badge>
              </b-form-group>
            </b-col>
            <b-col md="6" v-if="model.new_password">
              <b-form-group>
                <label for="ph_pass2">Password Repeat(*)</label>
                <b-form-input type="password" id="ph_pass2" v-model="model.new_password_repeat" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <label for="ph_nickname">Nick Name(*)</label>
                <b-form-input type="text" id="ph_nickname" v-model="model.nickname" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <label for="ph_group" v-b-tooltip.hover title="Enter a single IP or network range, etc) 192.168.0.100, 192.168.0.0/24 ">Allowed IP</label>
                <b-form-textarea ref="allow_ip_list" :rows="model && model.allow_ip ? model.allow_ip.length + 2 : 0" max-rows="10" v-model="model.allow_ip_list" :plaintext="lock">
                </b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <h4>Region</h4>
          <hr>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <label for="ph_country_group" v-b-tooltip.hover title="country">Country(*)</label>
                <v-select :readonly="true" @input="set_country" :disabled="lock" label="name" v-model="region.country" :options="codes.country" ></v-select>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="ph_language_group" v-b-tooltip.hover title="language">language(*)</label>
                <v-select :readonly="true" @input="set_language" :disabled="lock" label="name" v-model="region.language" :options="codes.language"></v-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <label for="ph_timezone_group" v-b-tooltip.hover title="Timezone">Timezone(*)</label>
                <v-select :readonly="true" @input="set_timezone" :disabled="lock" label="name" v-model="region.timezone" :options="codes.timezone" ></v-select>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <template v-if="lock">
            <b-button size="sm" variant="warning" @click="edit"> Edit </b-button>
            <b-button size="sm" variant="danger" @click="confirm = true"> Remove </b-button>
            <b-button size="sm" variant="info" @click="send_password_reset_mail" v-if="model.id"> Send Password Reset Mail </b-button>
          </template>
          <template v-else>
            <b-button size="sm" variant="success" @click="save"> Save </b-button>
            <b-button size="sm" variant="secondary" @click="cancel"> Cancel </b-button>
          </template>
          <b-button size="sm" class="float-right" variant="primary" @click="list"> List </b-button>
        </b-card>
      </b-tab>
      <b-tab title="Admin Login Log" :disabled="!model.id" @click="() => this.$refs._login_list && this.$refs._login_list.refresh()">
        <log-Login-List v-if="model.id" :user="model" ref="_login_list"></log-Login-List>
      </b-tab>
      <b-tab title="Admin Action Log" :disabled="!model.id" @click="() => this.$refs._action_list && this.$refs._action_list.refresh()">
        <log-Action-List v-if="model.id" :user="model" ref="_action_list"></log-Action-List>
      </b-tab>
    </b-tabs>

    <!-- 해당 파트너의 로그인 로그 정보 -->
    <!-- 해당 파트너의 액션 로그 정보 -->
    <!-- 안내 모달 시작 -->
    <b-modal title="admin Remove"  class="modal-danger" v-model="confirm" @ok="remove" ok-variant="danger">
      Are you sure you want to delete this user?
    </b-modal>
    <!-- 안내 모달 끝 -->
  </div>
</template>

<script>

const default_model = () => (
  { is_alive : true, permissions : 'Owner' }
);


import codes from '@/codes';
import { Api } from '@/service';
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import * as forge from 'node-forge'
import * as _ from 'lodash';
import reg from '@/reg';

// another vue
import logLoginList from '../../Log/login/Login.List.Admin'
import logActionList from '../../Log/action/Action.List.Admin'

export default {
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  components: {
    cSwitch,
    vSelect,
    logLoginList,
    logActionList
  },
  data : () => ({
      codes,
      confirm: false,
      add: false,
      lock: true,
      group_list: undefined,
      model : default_model(),
      allowed: false,
      region : {
        language : codes.language_default,
        country : codes.country_default,
        timezone : codes.timezone_default
      },
      password_meter : { is_spacial : false, is_alphabat_upper : false, is_alphabat_lower : false, is_number : false, check_length : false  },
  }),
  computed: {
    // profile() { return auth.profile; }
  },
  methods: {
    async send_password_reset_mail() {
      let rs = await Api.Manager_Call('admin', 'mail.pw.reset', { user_id : this.model.id });
      return rs.is_error ? this.$toastr.e("sending Password Reset Mail", "failed") : this.$toastr.s("Password Reset Mail", "Sented");
    },
    password_policy(type = '')
    {
      switch (type) {
        case 'number':
          this.password_meter.is_number = this.model.new_password && reg.reg_number.test(this.model.new_password) ? true : false;
          return this.password_meter.is_number;
        case 'uppercase':
          this.password_meter.is_alphabat_upper = this.model.new_password && reg.reg_alphabat_upper.test(this.model.new_password) ? true : false;
          return this.password_meter.is_alphabat_upper;
        case 'lowercase':
          this.password_meter.is_alphabat_lower = this.model.new_password && reg.reg_alphabat_lower.test(this.model.new_password) ? true : false;
          return this.password_meter.is_alphabat_lower;
        case 'spacial':
          this.password_meter.is_spacial = this.model.new_password && reg.reg_spacial.test(this.model.new_password) ? true : false;
          return this.password_meter.is_spacial;
        case 'length':
          this.password_meter.check_length = (this.model.new_password && this.model.new_password.length >= 10) ? true : false
          return this.password_meter.check_length;
        // eslint-disable-next-line no-case-declarations
        case 'all':
          let keys = Object.keys(this.password_meter);
          for (let i = 0; i < keys.length; i++) {
            // if has can't pass
            if(!this.password_meter[keys[i]]) { return { is_error : true, key : keys[i] }; }
          }
          // all pass
          return { is_error : false };
        default:
          return false;
      }
    },
    cancel: function() {
      if(this.$route.params.id == "add") { this.list(); }
      this.lock = true
    },
    edit:function() {
      this.lock = false
    },
    set_country:function(x) { if(!x) { return; } this.model.country = x.value },
    set_timezone:function(x) { if(!x) { return; } this.model.timezone = x.value },
    set_language:function(x) { if(!x) { return; } this.model.language = x.value },
    async remove() {
      try {
        let rs  = await Api.Manager_Call('admin', 'delete', {id : this.model.id});
        if(!rs.error) {
          this.$toastr.s('Removed'); this.list();
        } else {
          this.$toastr.e('delete', "failed"); this.cancel();
        }
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); this.list(); }
    },
    list() { this.$router.push({ name: 'admin'}); this.$emit('refresh'); },
    async save() {
      let model = {}

      // check validation
      try {
        if(!(this.model.username || '').trim()) { return this.$toastr.e('Username(ID) Required.'); }
        // if(!this.model.id && !this.model.new_password) { return this.$toastr.e('Password Required.'); }
        if(this.model.new_password && this.model.new_password != this.model.new_password_repeat) { return this.$toastr.e('Password repeat do not match'); }
        // if(!(this.model.nickname || '').trim()) { return this.$toastr.e('Nickname Required.'); }
        if(this.model.new_password) {
          var rs = this.password_policy('all')
          if(rs.is_error) {
            var msg = rs.key.indexOf('is') > -1 ? rs.key.substring(3) : rs.key;
            return this.$toastr.e(`Please check password policy [${msg}]`);
          }
        }
      } catch (e) { console.log(e); return this.$toastr.e('check validation failed'); }

      // build data for sending
      model = Object.assign({}, this.model, { permissions : codes.permissions_admin_value[this.model.permissions] })
      if(model.new_password) { model.new_password = forge.sha256.create().update(model.new_password).digest().toHex(); }
      if(model.group && model.group.id) { model.group_id = model.group.id; }
      if(this.model.allow_ip_list) {
        model.allow_ip = _.uniq(_.compact(this.model.allow_ip_list.replace(/,/gm, '').split("\n")));
        // b-form-textarea has bug, can not bind model so rirect update
        this.model.allow_ip_list = _.join(model.allow_ip, '\n')
        this.$refs.allow_ip_list.localValue = _.join(model.allow_ip, '\n')
      } else { model.allow_ip = "" }

      // set region
      if(!this.region.country) { return this.$toastr.e('Country Required.'); }
      if(!this.region.timezone) { return this.$toastr.e('Timezone Required.'); }
      if(!this.region.language) { return this.$toastr.e('Language Required.'); }

      let region = {};
      region.country = this.region.country.value
      region.language = this.region.language.value
      region.timezone = this.region.timezone.value

      try {
        let rs = await Api.Manager_Call('admin', this.model.id ? 'update' : 'insert', Object.assign({}, this.model, model, region));
        if(!rs.error) {
          this.model.new_password = ""
          this.model.new_password_repeat = ""
          this.$toastr.s('Saved', this.$route.name);
        } else {
          this.$toastr.e('Save', "failed"); this.list();
        }
        this.refresh(rs.body.id);
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }

      this.lock = true;
    },
    refresh(id) {
      this.$router.push({ name: 'admin', params : { id : id ? id : this.$route.params.id } });
    },
    async get({ id, tag } = this.$route.params) {
      this.model = default_model()

      console.log('admin.detail.vue', 'load item', id);
      if(id === 'add') { this.add = true; this.lock = false; this.model.is_alive = true; return; }
      try{
        this.model.id = Number(id);
        this.add = false;
        this.lock = (tag != 'edit');

        let rs = await Api.Manager_Call('admin', 'detail', { id : id })
        this.model = Object.assign({ group: {} }, this.model, rs.body)

        let is_done_country = false;
        codes.country.forEach(r => { if(is_done_country) { return; } else if(this.model.country && r.value == this.model.country.toUpperCase()) { this.region.country = r; is_done_country = true } });

        let is_done_language = false;
        codes.language.forEach(r => { if(is_done_language) { return; } else if(this.model.language && r.value == this.model.language.toUpperCase()) { this.region.language = r; is_done_language = true } });

        let is_done_timezone = false;
        codes.timezone.forEach(r => { if(is_done_timezone) { return; } else if(this.model.timezone && r.value == this.model.timezone) { this.region.timezone = r; is_done_timezone = true } });

        this.model.allow_ip_list = this.model.allow_ip && this.model.allow_ip.join("\n")

      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText), this.list() }
    }
  },
  created() { console.log('admin_Detail.vue', 'created'); },
  destroyed() { console.log('admin_Detail.vue', 'destroyed'); },
  mounted() {
    console.log('admin_Detail.vue', 'mounted');
    this.get(this.$route.params);
  },
}
</script>
